import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5A4A42', // Nav bar text color
      light: '#8A7A72',
      dark: '#3A2A22',
    },
    secondary: {
      main: '#C75D7B', // Accent color for buttons/links
      light: '#E88DA5',
      dark: '#A03D55',
    },
    background: {
      default: '#F6F1E7', // Warm cream background
      paper: '#ffffff',
    },
    text: {
      primary: '#000000', // Keep black for main content
      secondary: '#5A4A42', // Warm brown for secondary text
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#F6F1E7',
          color: '#5A4A42',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#5A4A42',
          color: '#F6F1E7',
          '&:hover': {
            backgroundColor: '#3A2A22',
          },
        },
      },
    },
  },
});

export default theme;

